const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Login {
  private uri: string;

  constructor(uri: string) {
    this.uri = uri;
  }

  public post = (params: any) => ({
    baseUrl,
    method: 'post',
    params,
    uri: this.uri,
  });
}

export default new Login('/auth/v1/login');



// WEBPACK FOOTER //
// ./src/libraries/api/login.tsx